var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1190.55,
    height: 210,
    viewBox: "0 0 1190.55 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1190.55,
    height: 210
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1190.55,
    height: 210,
    fill: "#091933"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-32 -32.097)",
    className: "animate-ping"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top_Plane",
    "data-name": "Top Plane",
    transform: "translate(988.495 32.097)",
    className: "animate-ping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    className: "animate-ping",
    "data-name": "Path 65",
    d: "M1971.925,319.1l5.935-9.13h7.076a2.037,2.037,0,0,0,2.195-1.827v-2.76a2.037,2.037,0,0,0-2.195-1.827h-2.905l2.865-4.407h5.951a2.037,2.037,0,0,0,2.2-1.827v-2.76a2.037,2.037,0,0,0-2.2-1.827h-1.78l6.219-9.566c1.82.076,3.5.117,5.005.117,21.759,0,53.046-4.828,53.046-10.783s-31.287-10.783-53.046-10.783c-1.524,0-3.226.042-5.072.121l-6.152-9.463h1.78a2.037,2.037,0,0,0,2.2-1.827v-2.76a2.037,2.037,0,0,0-2.2-1.827H1984.9l-2.865-4.407h2.905a2.037,2.037,0,0,0,2.195-1.827v-2.76a2.037,2.037,0,0,0-2.195-1.827h-7.076L1971.925,226a6.013,6.013,0,0,0-5.065-2.511h-2.016c-.669,0-1.163.518-1.012,1.059l3.1,11.107a1.963,1.963,0,0,0-1.83,1.8v1.764a2.037,2.037,0,0,0,2.2,1.827h1.14l1.518,5.438a1.952,1.952,0,0,0-1.776,1.793v1.763a2.037,2.037,0,0,0,2.195,1.827h1.084l3.243,11.613c-11.886,1.258-24.825,3.015-35.068,4.678l-11.52-14.756a3.008,3.008,0,0,0-2.533-1.256h-1.008c-.334,0-.581.259-.506.53l6.141,17.136c-5.888,1.133-9.595,2.106-9.594,2.679,0,.607,3.714,1.6,9.61,2.74l-6.157,17.182c-.075.27.172.53.506.53h1.008a3.009,3.009,0,0,0,2.533-1.257l11.553-14.8c10.243,1.66,23.177,3.4,35.057,4.64l-3.265,11.692h-1.084a2.037,2.037,0,0,0-2.195,1.827v1.763a1.951,1.951,0,0,0,1.776,1.793l-1.518,5.438h-1.14a2.037,2.037,0,0,0-2.2,1.827v1.763a1.962,1.962,0,0,0,1.83,1.8l-3.1,11.107c-.151.542.343,1.06,1.012,1.06h2.016A6.015,6.015,0,0,0,1971.925,319.1Z",
    transform: "translate(-1920.615 -223.493)",
    fill: "#709be0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    className: "animate-ping",
    "data-name": "Path 67",
    d: "M1056.67,0H0",
    transform: "translate(-59.5 81.53)",
    fill: "#ff0c0c",
    stroke: "#709be0",
    strokeWidth: 20,
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-193.89 -90.034)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 691.641,
    transform: "translate(758.5 198.5)",
    fill: "none",
    stroke: "#182c4d",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_Plane",
    "data-name": "Bottom Plane",
    transform: "translate(704.914 162.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1521.172,548.037l-3.333,6.845h-3.972a1.307,1.307,0,0,0-1.233,1.37v2.07a1.307,1.307,0,0,0,1.233,1.37h1.631l-1.609,3.3h-3.341a1.307,1.307,0,0,0-1.232,1.37v2.07a1.307,1.307,0,0,0,1.232,1.37h1l-3.492,7.173c-1.022-.057-1.965-.087-2.811-.087-12.217,0-29.784,3.62-29.784,8.085s17.567,8.086,29.784,8.086c.856,0,1.811-.031,2.848-.091l3.454,7.1h-1a1.307,1.307,0,0,0-1.232,1.37v2.07a1.307,1.307,0,0,0,1.232,1.37h3.341l1.609,3.3h-1.631a1.307,1.307,0,0,0-1.233,1.37v2.07a1.307,1.307,0,0,0,1.233,1.37h3.972l3.333,6.845a3.2,3.2,0,0,0,2.843,1.883h1.133a.634.634,0,0,0,.568-.794l-1.741-8.328a1.336,1.336,0,0,0,1.028-1.35v-1.322a1.307,1.307,0,0,0-1.232-1.37h-.64l-.853-4.078a1.341,1.341,0,0,0,1-1.345v-1.322a1.307,1.307,0,0,0-1.233-1.37h-.609l-1.82-8.708c6.674-.943,13.939-2.261,19.689-3.508l6.469,11.064a1.6,1.6,0,0,0,1.422.942h.567a.317.317,0,0,0,.283-.4l-3.448-12.849c3.306-.85,5.387-1.579,5.387-2.009,0-.455-2.085-1.2-5.4-2.055l3.457-12.883a.317.317,0,0,0-.283-.4h-.567a1.6,1.6,0,0,0-1.422.942l-6.487,11.095c-5.752-1.245-13.014-2.548-19.684-3.479l1.833-8.767h.609a1.307,1.307,0,0,0,1.233-1.37v-1.322a1.341,1.341,0,0,0-1-1.345l.853-4.078h.64a1.307,1.307,0,0,0,1.232-1.37v-1.322a1.335,1.335,0,0,0-1.028-1.35l1.741-8.328a.635.635,0,0,0-.568-.795h-1.133A3.2,3.2,0,0,0,1521.172,548.037Z",
    transform: "translate(-1475.46 -546.153)",
    fill: "#709be0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleImage);
export default __webpack_public_path__ + "static/media/title_image.5848222b724f1768f49bacfff0ee4d19.svg";
export { ForwardRef as ReactComponent };